import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GrowthbookFlagProtectedRouteProps } from 'src/routes/FlagProtectedRoute/GrowthbookFlagProtectedRoute/GrowthbookFlagProtectedRoute.types';
import { FEATURE_FLAGS } from 'src/utils/growthBook/growthBook.constants';

const GrowthbookFlagProtectedRoute: React.FC<
  GrowthbookFlagProtectedRouteProps
> = ({ flag, expectedValue, redirectTo = '/', children }) => {
  const featureKey = FEATURE_FLAGS[flag];
  const navigate = useNavigate();
  const isOn = useFeatureIsOn(featureKey);
  const value = useFeatureValue(featureKey, '');

  const [allowed, setAllowed] = useState<boolean>();

  useEffect(() => {
    if (expectedValue === 'on') {
      setAllowed(isOn);
    } else if (expectedValue === 'off') {
      setAllowed(!isOn);
    } else {
      setAllowed(isOn && value === expectedValue);
    }

    if (allowed === false) {
      navigate(redirectTo);
    }
  }, [allowed, expectedValue, isOn, value, navigate, redirectTo]);

  return allowed ? children : null;
};

export default GrowthbookFlagProtectedRoute;
